import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const getRequest = (data: any) => {
  return {
    approvalId: Number(data.id), // 0
    approvalType: data.approvalType, // 'DELETE_APPROVAL',
    status: data?.approvalStatus?.toLowerCase() === 'true' ? true : false, // true/false
    fileType: 0,
  }
}

const bulkMerchantProcessApprovals = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.merchantMappingProcessApproval),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequest(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { bulkMerchantProcessApprovals }
